export const InitContactModal = () => {
  const contactModal = document.getElementById("saf-contact-modal");
  const contactWidget = document.querySelector<HTMLElement>('.saf-contact-widget');
  const contactModalClose = document.getElementById("saf-contact-modal-close");

  contactWidget?.addEventListener('click', () => {
    contactModal?.classList.remove('hidden');
    document.body.classList.add('modal-open');
  })

  contactModalClose?.addEventListener('click', () => {
    contactModal?.classList.add('hidden');
    document.body.classList.remove('modal-open');
  })
}


